import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { AUTH_SERVER_URL } from '../../config';
import { Country } from '../models/v2/country';

const GET_COUNTRIES = `${ AUTH_SERVER_URL }/v2/countries`;

@Injectable({ providedIn: 'root' })
export class CountriesService {
	constructor(private readonly http: HttpClient) {}

	async getCountries() {
		return firstValueFrom(this.http.get<Country[]>(GET_COUNTRIES));
	}
}
